import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-dd5924fe"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "modal fade",
  id: "modalConfirmCommunity",
  tabindex: "-1",
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-lg" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = { class: "modal-title fw-bold text-center w-100" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn-close",
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}, null, -1))
const _hoisted_7 = { class: "modal-body w-100 mx-2" }
const _hoisted_8 = { class: "row mx-0 px-0 pb-4 gx-3 mb-2" }
const _hoisted_9 = { class: "w-max-content col-lg-4 col-form-label fw-bold" }
const _hoisted_10 = { class: "row mx-0 px-0 col-lg-8" }
const _hoisted_11 = { class: "col-lg-8 d-flex align-items-center" }
const _hoisted_12 = { class: "row mx-0 px-0 pb-4 gx-3 mb-2" }
const _hoisted_13 = { class: "w-max-content col-lg-4 col-form-label fw-bold" }
const _hoisted_14 = { class: "row mx-0 px-0 col-lg-8" }
const _hoisted_15 = { class: "col-lg-8 d-flex align-items-center" }
const _hoisted_16 = { class: "row mx-0 px-0 pb-4 gx-3" }
const _hoisted_17 = { class: "w-max-content col-lg-4 col-form-label fw-bold" }
const _hoisted_18 = { class: "row mx-0 px-0 col-lg-8" }
const _hoisted_19 = {
  key: 0,
  class: "col-lg-8 d-flex align-items-center pt-2"
}
const _hoisted_20 = {
  key: 1,
  class: "col-lg-8 d-flex align-items-center pt-2 not-entered"
}
const _hoisted_21 = { class: "fs-8" }
const _hoisted_22 = { class: "row mx-0 px-0 pb-4 gx-3 mb-2" }
const _hoisted_23 = { class: "w-max-content col-lg-4 col-form-label fw-bold" }
const _hoisted_24 = { class: "row mx-0 px-0 col-lg-8" }
const _hoisted_25 = { class: "col-lg-8 d-flex align-items-center break-spaces break" }
const _hoisted_26 = { class: "row mx-0 px-0 pb-4 gx-3" }
const _hoisted_27 = { class: "w-max-content col-lg-4 col-form-label fw-bold" }
const _hoisted_28 = { class: "row mx-0 px-0 col-lg-8" }
const _hoisted_29 = { class: "form-check-label fs-7 text-nowrap pt-2" }
const _hoisted_30 = {
  key: 0,
  class: "col-lg-8 d-flex align-items-center"
}
const _hoisted_31 = {
  key: 1,
  class: "col-lg-8 d-flex align-items-center not-entered"
}
const _hoisted_32 = { class: "form-check-label fs-7 text-nowrap pt-2" }
const _hoisted_33 = {
  key: 2,
  class: "col-lg-8 d-flex align-items-center break-spaces break"
}
const _hoisted_34 = {
  key: 3,
  class: "col-lg-8 d-flex align-items-center break-spaces break not-entered"
}
const _hoisted_35 = { class: "form-check-label fs-7 text-nowrap pt-2" }
const _hoisted_36 = { class: "col-lg-8 d-flex align-items-center break" }
const _hoisted_37 = ["href"]
const _hoisted_38 = {
  key: 1,
  class: "not-entered"
}
const _hoisted_39 = { class: "form-check-label fs-7 text-nowrap pt-2" }
const _hoisted_40 = { class: "col-lg-8 d-flex align-items-center break" }
const _hoisted_41 = ["href"]
const _hoisted_42 = {
  key: 1,
  class: "not-entered"
}
const _hoisted_43 = { class: "form-check-label fs-7 text-nowrap pt-2" }
const _hoisted_44 = { class: "col-lg-8 d-flex align-items-center break" }
const _hoisted_45 = ["href"]
const _hoisted_46 = {
  key: 1,
  class: "not-entered"
}
const _hoisted_47 = { class: "row mx-0 px-0 pb-4 gx-3 mb-2" }
const _hoisted_48 = {
  key: 0,
  class: "row mx-0 px-0 col-lg-8"
}
const _hoisted_49 = { class: "col-lg-8 d-flex align-items-center" }
const _hoisted_50 = ["src"]
const _hoisted_51 = {
  key: 1,
  class: "row mx-0 px-0 py-2 col-lg-8 not-entered"
}
const _hoisted_52 = { class: "row mx-0 px-0 pb-4 gx-3 mb-2" }
const _hoisted_53 = {
  key: 0,
  class: "row mx-0 px-0 col-lg-8"
}
const _hoisted_54 = { class: "col-lg-8 d-flex align-items-center" }
const _hoisted_55 = ["src"]
const _hoisted_56 = { class: "fs-8 mt-2" }
const _hoisted_57 = {
  key: 1,
  class: "row mx-0 px-0 py-2 col-lg-8"
}
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "not-entered" }, "(未設定)", -1))
const _hoisted_59 = { class: "fs-8" }
const _hoisted_60 = { class: "row mx-0 px-0 gx-3 mb-4" }
const _hoisted_61 = { class: "w-max-content col-lg-4 col-form-label fw-bold" }
const _hoisted_62 = { class: "row mx-0 px-0 col-lg-8" }
const _hoisted_63 = { class: "col-lg-8 d-flex align-items-center" }
const _hoisted_64 = { class: "row mx-0 px-0 gx-3 mb-4" }
const _hoisted_65 = { class: "w-max-content col-lg-4 col-form-label fw-bold" }
const _hoisted_66 = { class: "row mx-0 px-0 col-lg-8" }
const _hoisted_67 = { class: "col-lg-8 d-flex align-items-center" }
const _hoisted_68 = { class: "row mx-0 px-0 gx-3 mb-4" }
const _hoisted_69 = { class: "w-max-content col-lg-4 col-form-label fw-bold" }
const _hoisted_70 = { class: "row mx-0 px-0 col-lg-8" }
const _hoisted_71 = { class: "col-lg-8 d-flex align-items-center" }
const _hoisted_72 = { class: "row mx-0 px-0 gx-3 mb-4" }
const _hoisted_73 = { class: "w-max-content col-lg-4 col-form-label fw-bold" }
const _hoisted_74 = { class: "row mx-0 px-0 col-lg-8" }
const _hoisted_75 = {
  key: 0,
  class: "col-lg-8 d-flex align-items-center"
}
const _hoisted_76 = {
  key: 1,
  class: "col-lg-8 d-flex align-items-center"
}
const _hoisted_77 = { class: "row mx-0 px-0 gx-3 mb-4" }
const _hoisted_78 = { class: "w-max-content col-lg-4 col-form-label fw-bold" }
const _hoisted_79 = { class: "row mx-0 px-0 col-lg-8" }
const _hoisted_80 = { class: "col-lg-8 d-flex align-items-center" }
const _hoisted_81 = { class: "row mx-0 px-0 gx-3 mb-4" }
const _hoisted_82 = { class: "w-max-content col-lg-4 col-form-label fw-bold" }
const _hoisted_83 = { class: "row mx-0 px-0 col-lg-8" }
const _hoisted_84 = {
  key: 0,
  class: "col-lg-8 d-flex align-items-center"
}
const _hoisted_85 = {
  key: 1,
  class: "col-lg-8 d-flex align-items-center"
}
const _hoisted_86 = { class: "row mx-0 px-0 gx-3 mb-4" }
const _hoisted_87 = { class: "w-max-content col-lg-4 col-form-label fw-bold" }
const _hoisted_88 = { class: "row mx-0 px-0 col-lg-8" }
const _hoisted_89 = { class: "col-lg-8 d-flex align-items-center" }
const _hoisted_90 = {
  key: 0,
  class: "row mx-0 px-0 gx-3 mb-4"
}
const _hoisted_91 = { class: "w-max-content col-lg-4 col-form-label fw-bold" }
const _hoisted_92 = { class: "row mx-0 px-0 col-lg-8" }
const _hoisted_93 = { class: "col-lg-8 d-flex align-items-center" }
const _hoisted_94 = { class: "text-center mb-4" }
const _hoisted_95 = { class: "row" }
const _hoisted_96 = { class: "col-lg-6 d-flex justify-content-lg-end justify-content-center mb-4 mb-lg-0" }
const _hoisted_97 = { class: "col-lg-6 d-flex justify-content-lg-start justify-content-center" }

import { onMounted, PropType, ref } from 'vue'
import { useRoute } from 'vue-router'
import { Modal } from 'bootstrap'
import { useStore } from 'vuex'

import Button from '@/components/button/index.vue'
import { translate } from '@/languages/i18n'
import { buildFormData } from '@/utils'
import communityServices from '@/services/communities.service'
import { COMMUNITY_STORE } from '@/store/constants'
import { addCommunityHeaderParams, addUserIconParams } from '@/use/usePath'
import { YELLOOP_CHECK_FOLLOW_SETTING_LIST } from '@/constants/index'
import { computed } from 'vue'


export default /*#__PURE__*/_defineComponent({
  props: {
  data: {
    type: Object,
    default: () => ({
      name: '',
      display_corporation_name: '',
      operating_name: '',
      description: '',
      published: true,
    }),
  },
  showMessageError: {
    type: Function as PropType<() => void | undefined>,
  },
},
  setup(__props) {

const props = __props

const isShowFollowSetting = computed<boolean>(() => !!store.getters[COMMUNITY_STORE.GETTERS.COMMUNITY_INFO]?.yelloop_check_enable)
const route = useRoute()
const store = useStore()

const modalSuccess = ref()



const displayText = (value1: boolean, value2: boolean) => {
  if (value1 && value2) {
    return translate('almunai') + ' / ' + translate('employeeUser')
  }
  if (value1) {
    return translate('almunai')
  }
  if (value2) {
    return translate('employeeUser')
  }
  return translate('CO40NotAllowed')
}

const onSubmit = async (): Promise<void> => {
  const { data } = props
  props.showMessageError(false)

  const formData = new FormData()
  buildFormData(formData, {
    name: data.name,
    display_corporation_name: data.display_corporation_name,
    operating_name: data.operating_name,
    description: data.description,
    message_board_title: data.message_board_title,
    message_board_content: data.message_board_content,
    message_board_site_name_1: data.message_board_site_name_1,
    message_board_site_name_2: data.message_board_site_name_2,
    message_board_site_name_3: data.message_board_site_name_3,
    message_board_site_url_1: data.message_board_site_url_1,
    message_board_site_url_2: data.message_board_site_url_2,
    message_board_site_url_3: data.message_board_site_url_3,
    published: data.published,
    pending_notice: data.pending_notice,
    unsupported_operations_notice: data.unsupported_operations_notice,
    can_use_invited_code_of_alumni_users: data.can_use_invited_code_of_alumni_users,
    can_use_invited_code_of_employee_users: data.can_use_invited_code_of_employee_users,
    group_creation_by_alumni_users: data.group_creation_by_alumni_users,
    group_creation_by_employee_users: data.group_creation_by_employee_users,
    interest_display_setting_recruitment: data.interest_display_setting_recruitment,
    interest_display_setting_joboffer: data.interest_display_setting_joboffer,
    immediately_notice_setting_comment: data.immediately_notice_setting_comment,
    immediately_notice_setting_mention: data.immediately_notice_setting_mention,
    immediately_notice_setting_chatting: data.immediately_notice_setting_chatting,
    immediately_notice_setting_interested: data.immediately_notice_setting_interested,
  })
  if (isShowFollowSetting.value) {
    formData.append('yelloop_check_update_follow_setting', data.yelloop_check_update_follow_setting)
  }
  if (data.headerLogoImage?.file && data.headerLogoImage?.file !== data.image_url) {
    formData.append('image', data.headerLogoImage?.imgData)
  } else {
    if (data.image_url && data.headerLogoImage?.file !== data.image_url) {
      formData.append('remove_image', true)
    }
  }
  if (data.officeProfileImage?.file && data.officeProfileImage?.file !== data.profile_image_url) {
    formData.append('profile_image', data.officeProfileImage?.imgData)
  } else {
    if (data.profile_image_url && data.officeProfileImage?.file !== data.profile_image_url) {
      formData.append('remove_profile_image', true)
    }
  }

  try {
    const response = await communityServices.updateCommunityApi({ id: route.params?.id, formData: formData })

    if (response.status === 200) {
      store.dispatch(COMMUNITY_STORE.ACTIONS.UPDATE_COMMUNITY_INFO, {
        name: data.name,
        display_corporation_name: data.display_corporation_name,
        operating_name: data.operating_name,
        description: data.description,
        message_board_title: data.message_board_title,
        message_board_content: data.message_board_content,
        message_board_site_name_1: data.message_board_site_name_1,
        message_board_site_name_2: data.message_board_site_name_2,
        message_board_site_name_3: data.message_board_site_name_3,
        message_board_site_url_1: data.message_board_site_url_1,
        message_board_site_url_2: data.message_board_site_url_2,
        message_board_site_url_3: data.message_board_site_url_3,
        published: data.published,
        image_url:
          data.headerLogoImage?.imgData && typeof data.headerLogoImage?.imgData !== 'string' ? URL.createObjectURL(data.headerLogoImage?.imgData) : data.headerLogoImage?.imgData,
        profile_image_url:
          data.officeProfileImage?.imgData && typeof data.officeProfileImage?.imgData !== 'string'
            ? URL.createObjectURL(data.officeProfileImage?.imgData)
            : data.officeProfileImage?.imgData,
        pending_notice: data.pending_notice,
        unsupported_operations_notice: data.unsupported_operations_notice,
        can_use_invited_code_of_alumni_users: data.can_use_invited_code_of_alumni_users,
        can_use_invited_code_of_employee_users: data.can_use_invited_code_of_employee_users,
        group_creation_by_alumni_users: data.group_creation_by_alumni_users,
        group_creation_by_employee_users: data.group_creation_by_employee_users,
        interest_display_setting_recruitment: data.interest_display_setting_recruitment,
        interest_display_setting_joboffer: data.interest_display_setting_joboffer,
        immediately_notice_setting_comment: data.immediately_notice_setting_comment,
        immediately_notice_setting_mention: data.immediately_notice_setting_mention,
        immediately_notice_setting_chatting: data.immediately_notice_setting_chatting,
        immediately_notice_setting_interested: data.immediately_notice_setting_interested,
        yelloop_check_update_follow_setting: data.yelloop_check_update_follow_setting,
      })
      modalSuccess.value?.show()

      props.showMessageError(false)
      return
    }

    props.showMessageError(true)
  } catch (error) {
    console.log(error)
    props.showMessageError(true)
  }
}

onMounted(() => {
  modalSuccess.value = new Modal(document.getElementById('modalUpdateCommunitySuccess'))
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h5", _hoisted_5, _toDisplayString(_unref(translate)('CO41title')), 1),
          _hoisted_6
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("form", {
            onSubmit: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["prevent"]))
          }, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("label", _hoisted_9, _toDisplayString(_unref(translate)('communityName')), 1),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, _toDisplayString(__props.data.name), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("label", _hoisted_13, _toDisplayString(_unref(translate)('publicOrganizationName')), 1),
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, _toDisplayString(__props.data.display_corporation_name), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("label", _hoisted_17, _toDisplayString(_unref(translate)('managementOfficeName')), 1),
              _createElementVNode("div", _hoisted_18, [
                (__props.data.operating_name)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_19, _toDisplayString(__props.data.operating_name), 1))
                  : (_openBlock(), _createElementBlock("div", _hoisted_20, "(未入力）")),
                _createElementVNode("p", _hoisted_21, _toDisplayString(_unref(translate)('notEnteredCase')), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("label", _hoisted_23, _toDisplayString(_unref(translate)('explanatoryText')), 1),
              _createElementVNode("div", _hoisted_24, [
                _createElementVNode("div", _hoisted_25, _toDisplayString(__props.data.description), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_26, [
              _createElementVNode("label", _hoisted_27, _toDisplayString(_unref(translate)('messageBoard')), 1),
              _createElementVNode("div", _hoisted_28, [
                _createElementVNode("label", _hoisted_29, _toDisplayString(_unref(translate)('messageBoardTitle')), 1),
                (__props.data.message_board_title)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_30, _toDisplayString(__props.data.message_board_title), 1))
                  : (_openBlock(), _createElementBlock("div", _hoisted_31, "(未入力）")),
                _createElementVNode("label", _hoisted_32, _toDisplayString(_unref(translate)('messageBoardContent')), 1),
                (__props.data.message_board_content)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_33, _toDisplayString(__props.data.message_board_content), 1))
                  : (_openBlock(), _createElementBlock("div", _hoisted_34, "(未入力）")),
                _createElementVNode("label", _hoisted_35, _toDisplayString(_unref(translate)('messageBoardSite1')), 1),
                _createElementVNode("div", _hoisted_36, [
                  (__props.data.message_board_site_name_1 || __props.data.message_board_site_url_1)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 0,
                        href: __props.data.message_board_site_url_1,
                        target: "_blank"
                      }, _toDisplayString(__props.data.message_board_site_name_1 || __props.data.message_board_site_url_1), 9, _hoisted_37))
                    : (_openBlock(), _createElementBlock("div", _hoisted_38, "(未入力）"))
                ]),
                _createElementVNode("label", _hoisted_39, _toDisplayString(_unref(translate)('messageBoardSite2')), 1),
                _createElementVNode("div", _hoisted_40, [
                  (__props.data.message_board_site_name_2 || __props.data.message_board_site_url_2)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 0,
                        href: __props.data.message_board_site_url_2,
                        target: "_blank"
                      }, _toDisplayString(__props.data.message_board_site_name_2 || __props.data.message_board_site_url_2), 9, _hoisted_41))
                    : (_openBlock(), _createElementBlock("div", _hoisted_42, "(未入力）"))
                ]),
                _createElementVNode("label", _hoisted_43, _toDisplayString(_unref(translate)('messageBoardSite3')), 1),
                _createElementVNode("div", _hoisted_44, [
                  (__props.data.message_board_site_name_3 || __props.data.message_board_site_url_3)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 0,
                        href: __props.data.message_board_site_url_3,
                        target: "_blank"
                      }, _toDisplayString(__props.data.message_board_site_name_3 || __props.data.message_board_site_url_3), 9, _hoisted_45))
                    : (_openBlock(), _createElementBlock("div", _hoisted_46, "(未入力）"))
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_47, [
              _createElementVNode("label", {
                class: _normalizeClass(['w-max-content col-lg-4 col-form-label fw-bold', __props.data.headerLogoImage?.file ? 'mt-4' : ''])
              }, _toDisplayString(_unref(translate)('headerLogo')), 3),
              (__props.data.headerLogoImage?.file)
                ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                    _createElementVNode("div", _hoisted_49, [
                      _createElementVNode("img", {
                        src: _unref(addCommunityHeaderParams)(__props.data.headerLogoImage?.imgPreview),
                        alt: "img"
                      }, null, 8, _hoisted_50)
                    ])
                  ]))
                : _createCommentVNode("", true),
              (!__props.data.headerLogoImage?.file)
                ? (_openBlock(), _createElementBlock("div", _hoisted_51, " （未設定） "))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_52, [
              _createElementVNode("label", {
                class: _normalizeClass(['w-max-content col-lg-4 col-form-label fw-bold', __props.data.officeProfileImage?.file ? 'mt-4' : ''])
              }, _toDisplayString(_unref(translate)('managementOfficeProfileImage')), 3),
              (__props.data.officeProfileImage?.file)
                ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
                    _createElementVNode("div", _hoisted_54, [
                      _createElementVNode("img", {
                        class: "rounded-circle",
                        src: _unref(addUserIconParams)(__props.data.officeProfileImage?.imgPreview, 'community_admin'),
                        alt: "img"
                      }, null, 8, _hoisted_55)
                    ]),
                    _createElementVNode("div", _hoisted_56, _toDisplayString(_unref(translate)('CO40noticeImage')), 1)
                  ]))
                : _createCommentVNode("", true),
              (!__props.data.officeProfileImage?.file)
                ? (_openBlock(), _createElementBlock("div", _hoisted_57, [
                    _hoisted_58,
                    _createElementVNode("div", _hoisted_59, _toDisplayString(_unref(translate)('CO40noticeImage')), 1)
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_60, [
              _createElementVNode("label", _hoisted_61, _toDisplayString(_unref(translate)('publicSettings')), 1),
              _createElementVNode("div", _hoisted_62, [
                _createElementVNode("div", _hoisted_63, _toDisplayString(__props.data.published ? _unref(translate)('public') : _unref(translate)('private')), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_64, [
              _createElementVNode("label", _hoisted_65, _toDisplayString(_unref(translate)('invitationCodeSettings')), 1),
              _createElementVNode("div", _hoisted_66, [
                _createElementVNode("div", _hoisted_67, _toDisplayString(displayText(__props.data.can_use_invited_code_of_alumni_users, __props.data.can_use_invited_code_of_employee_users)), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_68, [
              _createElementVNode("label", _hoisted_69, _toDisplayString(_unref(translate)('groupCreateSettings')), 1),
              _createElementVNode("div", _hoisted_70, [
                _createElementVNode("div", _hoisted_71, _toDisplayString(displayText(__props.data.group_creation_by_alumni_users, __props.data.group_creation_by_employee_users)), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_72, [
              _createElementVNode("label", _hoisted_73, _toDisplayString(_unref(translate)('CO40interestUserDisplaySetting')), 1),
              _createElementVNode("div", _hoisted_74, [
                (__props.data.interest_display_setting_recruitment || __props.data.interest_display_setting_joboffer)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_75, _toDisplayString([
                      ...(__props.data.interest_display_setting_recruitment ? [_unref(translate)('recruitment')] : []),
                      ...(__props.data.interest_display_setting_joboffer ? [_unref(translate)('jobOffer')] : []),
                    ].join(' / ')), 1))
                  : (_openBlock(), _createElementBlock("div", _hoisted_76, _toDisplayString(_unref(translate)('CO40NotDisplayed')), 1))
              ])
            ]),
            _createElementVNode("div", _hoisted_77, [
              _createElementVNode("label", _hoisted_78, _toDisplayString(_unref(translate)('pendingNoticeSettings')), 1),
              _createElementVNode("div", _hoisted_79, [
                _createElementVNode("div", _hoisted_80, _toDisplayString(__props.data.pending_notice ? _unref(translate)('receive') : _unref(translate)('notReceive')), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_81, [
              _createElementVNode("label", _hoisted_82, _toDisplayString(_unref(translate)('CO40emailNotificationInstant')), 1),
              _createElementVNode("div", _hoisted_83, [
                (
                    __props.data.immediately_notice_setting_comment ||
                    __props.data.immediately_notice_setting_chatting ||
                    __props.data.immediately_notice_setting_mention ||
                    __props.data.immediately_notice_setting_interested
                  )
                  ? (_openBlock(), _createElementBlock("div", _hoisted_84, _toDisplayString([
                      ...(__props.data.immediately_notice_setting_comment ? [_unref(translate)('CO40settingComment')] : []),
                      ...(__props.data.immediately_notice_setting_chatting ? [_unref(translate)('CO40settingChatting')] : []),
                      ...(__props.data.immediately_notice_setting_mention ? [_unref(translate)('CO40settingMention')] : []),
                      ...(__props.data.immediately_notice_setting_interested ? [_unref(translate)('CO40settingInterested')] : []),
                    ].join(' / ')), 1))
                  : (_openBlock(), _createElementBlock("div", _hoisted_85, _toDisplayString(_unref(translate)('CO40NotReceived')), 1))
              ])
            ]),
            _createElementVNode("div", _hoisted_86, [
              _createElementVNode("label", _hoisted_87, _toDisplayString(_unref(translate)('unsupportedOperationsNoticeSettings')), 1),
              _createElementVNode("div", _hoisted_88, [
                _createElementVNode("div", _hoisted_89, _toDisplayString(__props.data.unsupported_operations_notice ? _unref(translate)('receive') : _unref(translate)('notReceive')), 1)
              ])
            ]),
            (_unref(isShowFollowSetting))
              ? (_openBlock(), _createElementBlock("div", _hoisted_90, [
                  _createElementVNode("label", _hoisted_91, _toDisplayString(_unref(translate)('CO40YelloopCheckFollowTitle')), 1),
                  _createElementVNode("div", _hoisted_92, [
                    _createElementVNode("div", _hoisted_93, _toDisplayString(_unref(YELLOOP_CHECK_FOLLOW_SETTING_LIST).get(__props.data.yelloop_check_update_follow_setting) || ''), 1)
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_94, _toDisplayString(_unref(translate)('CD40textConfirm')), 1),
            _createElementVNode("div", _hoisted_95, [
              _createElementVNode("div", _hoisted_96, [
                _createVNode(Button, {
                  title: _unref(translate)('cancel'),
                  type: 'secondary',
                  "data-bs-dismiss": "modal"
                }, null, 8, ["title"])
              ]),
              _createElementVNode("div", _hoisted_97, [
                _createVNode(Button, {
                  title: _unref(translate)('update'),
                  type: 'secondary',
                  onClick: onSubmit,
                  "data-bs-dismiss": "modal"
                }, null, 8, ["title"])
              ])
            ])
          ], 32)
        ])
      ])
    ])
  ]))
}
}

})